import React from "react";
import moment from "moment";

const ViewScreenTableContainer = ({ el }) => {
    return (
        <>
            <tr>
                <th scope="col" className="text-uppercase">
                Date
                </th>
                <td>{el.date}</td>
            </tr>
            <tr>
                <th scope="row" className="text-uppercase">
                Start Time
                </th>
                <td>{moment(el?.startTime).format("HH:mm:ss")}</td>
            </tr>
            <tr>
                <th scope="row" className="text-uppercase">
                End Time
                </th>
                <td>{moment(el?.endTime).format("HH:mm:ss")}</td>
            </tr>
            <tr>
                <th scope="row" className="text-uppercase">
                Client
                </th>
                <td>{el?.clientName}</td>
            </tr>
            <tr>
                <th scope="row" className="text-uppercase">
                Project
                </th>
                <td>{el?.projectName}</td>
            </tr>

            <tr>
                <th scope="row" className="text-uppercase">
                    Private
                </th>
                <td>{el?.privateHours}</td>
            </tr>

            <tr>
                <th scope="row" className="text-uppercase">
                Active
                </th>
                <td>{el?.activeHours}</td>
            </tr>
            <tr>
                <th scope="row" className="text-uppercase">
                Idle
                </th>
                <td>{el?.idleHours}</td>
            </tr>
            <tr>
                <th scope="row" className="text-uppercase">
                Manual
                </th>
                <td>{el?.manualHours}</td>
            </tr>
            <tr>
                <th scope="row" className="text-uppercase">
                Break
                </th>
                <td>{el?.breakHours}</td>
            </tr>
            <tr>
                <th scope="row" className="text-uppercase">
                Total
                </th>
                <td>{el?.totalHours}</td>
            </tr>
        </>
    )
}

export default ViewScreenTableContainer;